import React from 'react';
import { Clock } from 'lucide-react';
import { SourceTime } from './SourceTime';

export const ReceiptDateCell = ({ receipt, onEdit, canWrite }) => (
  <td data-testid={`receipt-datetime-cell-${receipt.id}`} className="min-w-[156px] whitespace-nowrap py-3 px-4 text-sm text-gray-900 align-top">
    <div className="flex items-center gap-2">
      <span data-testid={`receipt-bank-date-${receipt.id}`}>{receipt.date || '—'}</span>
      {receipt.recovered && onEdit && (
        <button type="button" disabled={!canWrite} onClick={() => onEdit(receipt)}
          data-testid={`edit-recovered-time-${receipt.id}`}
          title="Editar fecha/hora (reubica cronológicamente)"
          aria-label="Editar fecha y hora del comprobante recuperado"
          className="shrink-0 rounded p-0.5 text-orange-600 transition-colors hover:bg-orange-100 disabled:opacity-40">
          <Clock className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
    {(receipt.time || receipt.recovered) && (
      <div data-testid={`receipt-bank-time-${receipt.id}`} title="Hora del comprobante o movimiento"
        className={`mt-0.5 text-xs tabular-nums ${receipt.recovered ? 'text-orange-700' : 'text-gray-600'}`}>
        {receipt.time || '--:--'}
      </div>
    )}
    <SourceTime receipt={receipt} />
  </td>
);